import React from "react";

import ChatBot from "@/Components/ChatBot/ChatBot.jsx";
import { Head } from "@inertiajs/react";
import { useLaravelReactI18n } from "laravel-react-i18n";
import Header from "@/Components/Header.jsx";

import Footer from "@/Components/Footer.jsx";
import DecorBlob from "@/Components/Decor/DecorBlob.jsx";
import DecorContainer from "@/Components/Decor/DecorContainer.jsx";
import Breadcrumbs from "@/Components/Breadcrumbs.jsx";
import CaseBlock from "@/Components/CaseBlock.jsx";

export default function News(pageProps) {
    const { t } = useLaravelReactI18n();
    const email = "info@vivanti.eu";
    const handleEmailClick = () => {
        window.location.href = `mailto:${email}`;
    };

    return (
        <>
            <ChatBot
                csrf_token={pageProps.csrf_token}
                user_id={pageProps.user_id}
                is_admin={pageProps.is_admin}
            ></ChatBot>

            <Head>
                <title>{pageProps.news.seo_title}</title>
                <meta name="title" content={pageProps.news.seo_title} />
                <meta name="description" content={pageProps.news.meta_description} />

                <meta property="og:title" content={pageProps.news.seo_title} />
                <meta
                    property="og:description"
                    content={pageProps.news.meta_description}
                />
                <meta
                    property="og:image"
                    content={require('@images/social-banners/main.jpg')}
                />
            </Head>

            <Header locale={pageProps.locale} menu={pageProps.menu}></Header>

            <section className="news news--big container mb-80px ph:mb-100px">
                <div className="container__inner">
                    <Breadcrumbs breadcrumbs={pageProps.breadcrumbs} pageName={pageProps.news.name} />

                    <div className="news__content">

                        <div className="news-card mt-70px">
                            <h1 className="news-card__title">{pageProps.news.name}</h1>
                            <img src={`/storage/${pageProps.news.big_image}`}
                                alt="preview"
                                className="news-card__preview-picture mt-48px"
                            />
                            <div className="news-card__service-info mt-48px">
                                <span className="news-card__date">{pageProps.news.published_at_localized}</span>
                                <div className="tags mt-[11px]">
                                    {
                                        pageProps.news.tags.map((tag) => {
                                            return <div key={tag.id} className="tag">
                                                <span>{tag.name}</span>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>


                            <div className="tinymce-content"
                                dangerouslySetInnerHTML={{
                                    __html: pageProps.news.body
                                }}
                            >
                            </div>
                        </div>
                        {pageProps.news.cases.length !== 0 && <div className="news__case mt-80px">

                            <h4>{t("site.infoNewsCase.caseTitle")}</h4>
                            {
                                pageProps.news.cases.map((data) => {
                                    return <CaseBlock data={data} locale={pageProps.locale} />
                                })
                            }

                        </div>
                        }
                    </div>
                </div>

                <DecorContainer>
                    <DecorBlob
                        typeNum={1}
                        width={960}
                        blur={0}
                        rotate={13}
                        opacity={1}
                        x={740}
                        y={-795}
                    />
                    <DecorBlob
                        typeNum={1}
                        width={1227}
                        blur={0}
                        rotate={-165}
                        opacity={0.3}
                        x={1100}
                        y={200}
                        animations={["pulse"]}
                        animDuration={6}
                        gsapMove={true}
                    />
                    <DecorBlob
                        typeNum={3}
                        width={1200}
                        blur={80}
                        rotate={250}
                        opacity={1}
                        x={1000}
                        y={200}
                        animations={["pulse"]}
                        animDuration={12}
                        gsapMove={true}
                    />
                    <DecorBlob
                        typeNum={1}
                        width={1200}
                        blur={150}
                        rotate={-159}
                        opacity={1}
                        x={-960}
                        y={650}
                    />
                    <DecorBlob
                        typeNum={3}
                        width={1500}
                        blur={150}
                        rotate={-30}
                        opacity={1}
                        x={235}
                        y={1800}
                        animations={["pulse"]}
                        animDuration={8}
                        gsapMove={true}
                    />
                </DecorContainer>
            </section>

            <Footer pageProps={pageProps}></Footer>
        </>
    );
}
